/* Delegate to the current native Shopify mobile menu, preserving drawer functionality */
(()=>{"use strict";if(window.__gpMobileShortcutBound)return;window.__gpMobileShortcutBound=true;
document.addEventListener("click",e=>{const btn=e.target.closest("[data-gp-mobile-categories]");if(!btn)return;
const container=btn.closest(".header__drawer");const details=container?.querySelector("#Details-menu-drawer-container");const summary=details?.querySelector("summary");
if(summary){e.preventDefault();summary.click();}
});})();